module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/2-6f66f39e27c7a791526f700a8a288721.svg";